export default function About() {
  const el = document.createElement('div');
  el.innerHTML = `<h1>About</h1><p>Simple page</p>`;
  return el;
}
